import BankingProfileSummary from './BankingProfileSummary';

export default BankingProfileSummary;
